import { DEFAULT_FONTSIZE } from "./utils";

export const NO_NUMBER_ARROWS_MUI = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input": {
    fontSize: DEFAULT_FONTSIZE.fontSize,
  },
};

